import enUS from './translations/en-US'
import esES from './translations/es-ES'
import ptBR from './translations/pt-BR'

export interface Language {
  code: string;
  dateCode: string;
  name: string;
  default?: boolean;
  translations: any;
}

export interface Languages {
  [name: string]: Language;
}

export interface Translations {
  [name: string]: {
    [key: string]: any;
  };
}

export const LANGUAGES: Languages = {
  'pt-BR': { code: 'pt-BR', dateCode: 'pt', name: 'Português', translations: ptBR, default: true },
  'en-US': { code: 'en-US', dateCode: 'en', name: 'English', translations: enUS },
  'es-ES': { code: 'es-ES', dateCode: 'es', name: 'Español', translations: esES },
}
